<template>
  <div v-if="unfixeableClaimProduct">
    <div class="mt-2 flex justify-end">
      <SecondaryButton
        v-if="canUpdateStatus(unfixeableClaimProduct)"
        @click="openUnfixeableClaimProductUpdateModal = true"
      >
        Mettre à jour
      </SecondaryButton>
    </div>

    <div class="mt-4 relative bg-white rounded-2xl shadow-md p-6 mx-auto">
      <span
        :class="[
          'px-4 py-1 rounded-lg font-bold text-sm absolute top-4 right-4',
          statusStyle(unfixeableClaimProduct.status),
        ]"
      >
        {{ $t("unfixeable_claim_products.status." + unfixeableClaimProduct.status) }}
      </span>
      <h2 class="text-xl font-bold text-center mt-6 mb-8">{{ unfixeableClaimProduct.product?.title }}</h2>
      <div class="space-y-2">
        <FieldRow label="Sinistre">
          <span class="font-light text-primary hover:text-primary-dark cursor-pointer" @click="goToClaimDetails">
            {{ unfixeableClaimProduct.claimFriendlyId }}
          </span>
        </FieldRow>
        <FieldRow label="Marchand" :value="unfixeableClaimProduct.store" />
        <FieldRow
          label="Prix"
          :value="`${unfixeableClaimProduct.product?.price} ${unfixeableClaimProduct.product?.currencyCode}`"
        />
        <FieldRow label="Raison" :value="unfixeableClaimProduct.reason" />
        <FieldRow label="Numéro de suivi" :value="unfixeableClaimProduct.trackingNumber" />
        <FieldRow label="Valorisation" :value="unfixeableClaimProduct.valuationAmount" />
        <FieldRow v-if="unfixeableClaimProduct.irreparabilityCertificateUrl" label="Certificat d'irréparabilité">
          <a
            class="text-blue-400 underline"
            :href="unfixeableClaimProduct.irreparabilityCertificateUrl"
            target="_blank"
          >
            Lien
          </a>
        </FieldRow>
      </div>
    </div>

    <UnfixeableClaimProductUpdateModal
      :open="openUnfixeableClaimProductUpdateModal"
      :unfixeable-claim-product="unfixeableClaimProduct"
      @close="openUnfixeableClaimProductUpdateModal = false"
      @updated="fetchUnfixeableClaimProduct"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { FieldRow, SecondaryButton } from "@estaly/ui";
import UnfixeableClaimProductUpdateModal from "@/components/claim/unfixeable_claim_products/UpdateModal.vue";

export default {
  components: { SecondaryButton, UnfixeableClaimProductUpdateModal, FieldRow },
  data: () => {
    return {
      unfixeableClaimProduct: null,
      openUnfixeableClaimProductUpdateModal: false,
    };
  },

  async beforeMount() {
    await this.fetchUnfixeableClaimProduct();
  },

  computed: {
    ...mapGetters("unfixeableClaimProducts", ["statusStyle", "canUpdateStatus"]),

    unfixeableClaimProductId() {
      return this.$route.params.id;
    },
  },

  methods: {
    ...mapActions("unfixeableClaimProducts", ["fetch"]),

    async fetchUnfixeableClaimProduct() {
      this.unfixeableClaimProduct = await this.fetch({ id: this.unfixeableClaimProductId });
    },

    goToClaimDetails() {
      if (this.unfixeableClaimProduct.claimFriendlyId)
        this.$router.push(`/claims/${this.unfixeableClaimProduct.claimFriendlyId}`);
    },
  },
};
</script>
